DJ.addBehavior('accordeon-footer', '.js-accordeons-footer', {
  attach: function (context, settings, behavior) {
    var $holder = jQuery(this);
    var $toggles = $holder.find('.accordeon-title');

    $toggles.on('click', function () {
      var $this = jQuery(this);
      var $parent = $this.closest('.accordeon');
      var $content = $parent.find('.accordeon-content');
      var isAlreadyOpened = $parent.hasClass('opened');

      // Ferme les autres accordéons
      $holder.find('.accordeon.opened').not($parent).each(function () {
        var $acc = jQuery(this);
        var $btn = $acc.find('.accordeon-title');
        var $panel = $acc.find('.accordeon-content');
        $acc.removeClass('opened');
        $btn.attr('aria-expanded', 'false');
        $panel.attr('aria-hidden', 'true');
      });

      // Bascule celui cliqué
      if (isAlreadyOpened) {
        $parent.removeClass('opened');
        $this.attr('aria-expanded', 'false');
        $content.attr('aria-hidden', 'true');
      } else {
        $parent.addClass('opened');
        $this.attr('aria-expanded', 'true');
        $content.attr('aria-hidden', 'false');
      }
    });
  },

  detach: function (context, settings) {}
});
